import React from "react";

const HairScalpTreatmentTips = () => {
  return (
    <div className="hairSalonInSahakaraWhat">
      <h3>Tips to Maintain Scalp Health After Treatment</h3>
      <li>
        <span>1. Use sulfate-free shampoos and conditioners.</span>
      </li>
      <li>
        <span> 2. Avoid excessive heat styling or harsh chemicals.</span>
      </li>
      <li>
        <span>3. Protect your scalp from direct sunlight.</span>
      </li>
      <li>
        <span>4. Stay hydrated and maintain a balanced diet.</span>
      </li>
      <li>
        <span>5. Regularly visit SCENT for follow-up treatments.</span>
      </li>
    </div>
  );
};

export default HairScalpTreatmentTips;
